import { useEffect, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { http } from "@/lib/api";

export const useTenantSettings = () =>
  useQuery({ queryKey: ["tenant-settings"], queryFn: async () => (await http.get("/tenant-settings")).data });

export function useSaveSection() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ section, data }) => http.put(`/tenant-settings/${section}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["tenant-settings"] }),
  });
}

// Convenience: load one section into local form state with a save handler.
export function useSectionForm(section) {
  const { data, isLoading } = useTenantSettings();
  const save = useSaveSection();
  const [form, setForm] = useState(null);

  useEffect(() => {
    if (data?.sections?.[section]) setForm(JSON.parse(JSON.stringify(data.sections[section])));
  }, [data, section]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const setNested = (group, k, v) => setForm((f) => ({ ...f, [group]: { ...f[group], [k]: v } }));
  const submit = async (msg = "Settings saved") => {
    await save.mutateAsync({ section, data: form });
    toast.success(msg);
  };
  return { form, set, setNested, setForm, submit, saving: save.isPending, loading: isLoading || !form };
}
